module.exports = __webpack_public_path__ + "static/media/jobChangePopUp.9c496600.png";